import React from 'react';
import { Link } from 'react-router-dom';

const OfferingsSplit = () => {
  return (
    <section className="offering-feature" id="services">
      <div className="offering-feature-inner">
        <div className="offering-feature-media">
          <img
            src="/photobooth_services_photo.JPG"
            alt="The Retro Booth — a handmade wooden booth on a wooden tripod, set up at a wedding reception"
            loading="lazy"
            decoding="async"
          />
        </div>

        <div className="offering-feature-body">
          <p className="offering-feature-eyebrow">Our Signature</p>
          <h2 className="offering-feature-title">The Retro Booth</h2>
          <p className="offering-feature-copy">
            Handmade wooden booth with touchscreen, professional DSLR camera for stunning photo quality, a black or white backdrop &amp; instant digital sharing.
          </p>
          <Link to="/retro-booth" className="offering-feature-btn" data-track="home_services">
            See Retro Booth <span aria-hidden="true">&rarr;</span>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default OfferingsSplit;
